import { GROUP_COLORS } from './constants.js';

// Reference-Data variant of the column picker (uses GROUP_COLORS for the
// table heading color — the Rules version doesn't).
export function ColumnPicker({ columns, selectedCols, onToggle, onSelectTable }) {
  const tables = [...new Set(columns.map((c) => c.table))];
  return (
    <div
      style={{
        background: '#f8f9fa', border: '1px solid #dee2e6',
        borderRadius: 8, padding: '14px 18px', marginBottom: 12,
      }}
    >
      {tables.map((table) => {
        const tableCols = columns.filter((c) => c.table === table);
        const allSelected = tableCols.every((c) => selectedCols.has(c.key));
        const source = tableCols[0]?.group || '';
        return (
          <div key={table} style={{ marginBottom: 12 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
              <strong style={{
                fontSize: 12, letterSpacing: 0.3,
                color: GROUP_COLORS[source] || '#333',
              }}>
                {table}
              </strong>
              <span style={{ fontSize: 10, color: '#999' }}>({source})</span>
              <button
                onClick={() => onSelectTable(table)}
                style={{
                  fontSize: 10, padding: '1px 8px', borderRadius: 3, cursor: 'pointer',
                  border: '1px solid #aaa',
                  background: allSelected ? '#e8f5e9' : '#fff',
                }}
              >
                {allSelected ? 'Deselect All' : 'Select All'}
              </button>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px 16px' }}>
              {tableCols.map((col) => (
                <label key={col.key} style={{
                  fontSize: 12, display: 'flex', alignItems: 'center',
                  gap: 4, cursor: 'pointer', padding: '2px 0',
                }}>
                  <input
                    type="checkbox"
                    checked={selectedCols.has(col.key)}
                    onChange={() => onToggle(col.key)}
                  />
                  {col.label}
                </label>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
